import {
  type AccountData,
  type AccountId,
  type WorkflowStageId,
  type WorkflowData,
  getRecordingFlagStageIds,
  getAccountResidentName,
  isDefined,
  isNotEmpty,
} from '@terros/common'

export type RecordingLocationWarning = {
  accountId: AccountId
  accountName: string
  stageName: string
}

export function getRecordingLocationWarnings({
  accounts,
  workflows,
}: {
  accounts: AccountData[]
  workflows: WorkflowData[]
}): RecordingLocationWarning[] {
  const flagStages = new Map(
    workflows.flatMap((workflow) => {
      const ids = getRecordingFlagStageIds(workflow.stages)
      return workflow.stages
        .filter((stage) => ids.has(stage.stageId))
        .map((stage): [WorkflowStageId, string] => [stage.stageId, stage.name])
    })
  )
  return accounts.flatMap((account) => {
    const stageName = isDefined(account.workflowStageId) ? flagStages.get(account.workflowStageId) : undefined
    if (!isDefined(stageName)) return []
    const name = getAccountResidentName(account.resident)
    return [{ accountId: account.accountId, accountName: isNotEmpty(name) ? name : account.accountId, stageName }]
  })
}
